// 쿠키스토리 후원 칸 (2026-10-19, 클리커스토리 Support.tsx 이식)
// 한 줄 띠: 글은 왼쪽, 후원하기 버튼·QR은 오른쪽 (2026-10-19 김현비 선택)
// 모든 페이지 맨 아래(Footer) + 로그인·마이페이지 본문. 그 두 화면에선 맨 아래 칸을 숨긴다(Footer 참고).
import { useTranslation } from "react-i18next";
import "./Support.css";

export const SUPPORT_URL = "https://buymeacoffee.com/3dmakerz";

export default function Support({ className = "" }) {
  const { t } = useTranslation();
  return (
    <aside className={`support ${className}`} aria-label={t("support.title")}>
      <div className="support-text">
        <h2>{t("support.title")}</h2>
        <p>{t("support.desc")}</p>
        <small>{t("support.note")}</small>
      </div>
      <a className="support-link" href={SUPPORT_URL} target="_blank" rel="noopener noreferrer">
        {/* 이모지 ☕ 는 윈도우에서 보라색 동그라미처럼 그려져서 아이콘을 직접 그린다 */}
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
          strokeLinecap="round" strokeLinejoin="round" aria-hidden>
          <path d="M4 9h12v5a5 5 0 0 1-5 5H9a5 5 0 0 1-5-5V9z" />
          <path d="M16 11h1.5a2.5 2.5 0 0 1 0 5H16" />
          <path d="M8 3.5c0 1 1 1.5 1 2.5M12 3.5c0 1 1 1.5 1 2.5" />
        </svg>
        {t("support.btn")} <span aria-hidden>↗</span>
      </a>
      <a className="support-qr" href={SUPPORT_URL} target="_blank" rel="noopener noreferrer" aria-label={t("support.open")}>
        <img src="/brand/bmc-qr.png" width={84} height={84} loading="lazy" alt={t("support.qr_alt")} />
      </a>
    </aside>
  );
}
